// Çek / Senet Ekle penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'finance.addCheckNote';

export const addCheckNoteGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Çek / senet nasıl kaydedilir?'),
  intro: t(`${G}.intro`, 'Bu pencere tek bir çek veya senedi kaydeder ya da düzenler. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Yeni Çek / Yeni Senet'),
    body: t(`${G}.regions.body`, 'Kayıt formu'),
    footer: t(`${G}.regions.footer`, 'Kaydet'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Çek mi, senet mi?'),
      text: t(`${G}.s1.text`, 'Tür, sayfada bastığınız düğmeyle belirlenir: "Yeni Çek" mavi, "Yeni Senet" mor başlıklı formu açar. Çekte banka ve çek bilgileri, senette borçlu ve kefil bilgileri sorulur.'),
      tips: [
        t(`${G}.s1.tip1`, 'Belge numarası kayıtta otomatik verilir (çekte ÇK-yıl-sıra, senette SN-yıl-sıra). Belge Numarası alanına yazdığınız değer kullanılmaz.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Yön, para birimi ve cari'),
      text: t(`${G}.s2.text`, 'Yön: müşteriden aldıysanız "Alınan", tedarikçiye verdiyseniz "Verilen". Para Birimi TRY dışında seçilirse Döviz Kuru alanı açılır ve TCMB kuru (alış-satış ortalaması) otomatik gelir; yanındaki yenile düğmesiyle güncel kuru tekrar çekebilirsiniz. Sonra Cari Hesap\'ı seçin.'),
      tips: [
        t(`${G}.s2.tip1`, 'Cari Hesap alınan çek / senette ve verilen senette zorunludur. Yalnız verilen çekte boş bırakılabilir; o zaman cari hareket oluşmaz.'),
        t(`${G}.s2.tip2`, 'Düzenlemede yön ve cari değiştirilemez.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Çek bilgileri'),
      text: t(`${G}.s3.text`, 'Alınan çekte müşterinin çekindeki Banka Adı, Şube Adı, Şube Kodu, Çek Numarası ve Çek Hesap No\'yu yazın. Verilen çekte önce Çek Hesabı\'nı, sonra Çek Defteri\'ni seçin: banka adı, hesap no ve para birimi hesaptan gelir; sıradaki çek numarası otomatik yazılır, isterseniz değiştirebilirsiniz.'),
      tips: [
        t(`${G}.s3.tip1`, 'Çek Hesabı listesinde yalnız "Çek Hesabı" olarak işaretlenmiş banka hesapları görünür. Çek Defteri listesinde yalnız aktif ve boş yaprağı olan defterler çıkar; tek defter varsa kendiliğinden seçilir.'),
        t(`${G}.s3.tip2`, 'Verilen çekte çek defteri zorunludur ve çek numarası defterin numara aralığı dışında olamaz.'),
        t(`${G}.s3.tip3`, 'Çek numarası daha önce kullanıldıysa uyarı çıkar ve kullanılabilir ilk numara önerilir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Senet bilgileri'),
      text: t(`${G}.s4.text`, 'Senette Keşideci Adı (senedi imzalayan), Kefil Adı, Borçlu TC Kimlik No, Borçlu Adresi, Kefil TC Kimlik No, Kefil Adresi ve Yetkili Mahkeme alanları vardır. Hepsi isteğe bağlıdır; TC kimlik alanları en çok 11 hanedir.'),
    },
    {
      region: 'body',
      title: t(`${G}.s5.title`, '5. Tarih ve tutar'),
      text: t(`${G}.s5.text`, 'Düzenleme Tarihi ve Vade Tarihi bugünle başlar; Keşide Yeri isteğe bağlıdır. Vade Tarihi ve Tutar zorunludur; tutar sıfırdan büyük olmalıdır. Notlar ve Proje alanları isteğe bağlıdır.'),
      tips: [
        t(`${G}.s5.tip1`, 'Vade tarihi düzenleme tarihinden önce olamaz.'),
        t(`${G}.s5.tip2`, 'Döviz cinsinden kayıtta TL karşılığı = Tutar × Döviz Kuru olarak saklanır.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s6.title`, '6. Kaydedin'),
      text: t(`${G}.s6.text`, '"Kaydet" (düzenlemede "Güncelle") kaydı oluşturur. Alınan çek / senet "Portföyde" durumuyla başlar ve cari alacaklandırılır (müşterinin borcu azalır). Verilen çek / senet "Ödenmedi" durumuyla başlar ve cari borçlandırılır (ona olan borcumuz azalır).'),
      tips: [
        t(`${G}.s6.tip1`, 'Kasa ve banka bakiyesi kayıtta değişmez; para hareketi durum değiştirilince (Tahsil Edildi / Ödendi) oluşur.'),
        t(`${G}.s6.tip2`, 'Verilen çek kaydedilince seçilen defterden bir yaprak kullanılmış sayılır.'),
        t(`${G}.s6.tip3`, 'Kaydetmeden kapatırsanız değişiklikleri iptal etmek isteyip istemediğiniz sorulur.'),
      ],
    },
  ],
});
